<template>
  <div class="pt-35">
    <vs-tabs alignment="fixed">
      <vs-tab label="Банковский счёт">
        <form @submit.prevent data-vv-scope="bankForm">
          <InputAccountNumber
            v-model="formBank.account_number"
            errorsScope="formBank.account_number"
          />
          <vs-input
            label="БИК банка, выпустившего карту"
            placeholder="123456789"
            v-mask="'#########'"
            v-model="formBank.bik"
            v-validate="'required|regex:^[0-9]{9}$'"
            name="bik"
            :danger="errors.has('bankForm.bik')"
            danger-text="БИК должен состоять из 9 цифр"
          />
          <vs-input
            label="ФИО получателя денежных средств"
            name="account_name"
            placeholder="Иванов Иван Иванович"
            v-model.trim="formBank.account_name"
            v-validate="'required|fullName'"
            :danger="errors.has('bankForm.account_name')"
            :danger-text="errors.first('Введите полное ФИО на кириллице')"
          />
          <p class="mb-6">
            <small>
              Чтобы узнать реквизиты своего счета:<br>
              В мобильном приложении своего банка выберите карточку,
              на которую хотите получать чаевые, а дальше нажмите - получить реквизиты.
            </small>
          </p>
          <vs-button
            id="save-button"
            button="submit"
            :disabled="!validateForm1"
            @click="saveBankAccount('bankForm')"
          >Сохранить</vs-button>
        </form>
      </vs-tab>
      <vs-tab label="Личные данные">
        <form @submit.prevent data-vv-scope="userForm" id="employee-form">
          <div class="mb-6 justify-center">
            <AvatarCroperEmployee :curr_image.sync="prefillImage" :user_id.sync="this.employee"/>
            <!-- <picture-input
              ref="pictureInput"
              width="179"
              height="179"
              margin="0"
              size="20"
              plain
              radius="50"
              button-class="vs-component vs-button mb-2 vs-button-primary vs-button-filled"
              :custom-strings="uploadOptions"
              @change="onChange"
              :prefill="prefillImage"
            /> -->
          </div>
          <vs-input
            v-validate="'required|alpha|min:3'"
            data-vv-validate-on="blur"
            name="first_name"
            label="Имя*"
            description-text="Если отсутствует никнейм, то Имя будет отображено на карточке"
            v-model="userForm.first_name"
            :danger="errors.has('userForm.first_name')"
            :danger-text="errors.first('userForm.first_name')"
          />
          <vs-input
            v-validate="'alpha|min:3'"
            data-vv-validate-on="blur"
            name="last_name"
            label="Фамилия"
            v-model="userForm.last_name"
            :danger="errors.has('userForm.last_name')"
            :danger-text="errors.first('userForm.last_name')"
          />
          <vs-input
            data-vv-validate-on="blur"
            name="nickname"
            label="Отображаемое имя на карточке профиля (будет видно посетителям)"
            placeholder="Никнейм"
            v-model="userForm.nickname"
            :danger="errors.has('userForm.nickname')"
            :danger-text="errors.first('userForm.nickname')"
          />
          <InputPhone
            label="Телефон*"
            v-model="userForm.phone_number"
            errorsScope="userForm.phone_number"
          />
          <vs-input
            v-validate="'email'"
            data-vv-validate-on="blur"
            name="email"
            type="email"
            label="Почта"
            v-model="userForm.email"
            :danger="errors.has('userForm.email')"
            :danger-text="errors.first('userForm.email')"
          />
          <vs-input
            label="Фраза (будет видно посетителям)"
            name="public_phrase"
            v-model="userForm.public_phrase"
            :danger="errors.has('userForm.public_phrase')"
            :danger-text="errors.first('userForm.public_phrase')"
          />
          <div class="mb-6">
            <vs-checkbox v-model="userForm.branch_page_show"> Отображать на общей странице заведения</vs-checkbox>
          </div>
          <vs-button
            id="save-button"
            button="submit"
            :disabled="!validateForm2"
            @click="saveUserProfile('userForm')"
          >Сохранить
          </vs-button>
        </form>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import AuthService from '@/common/auth.service'
import { EMPLOYEE_UPDATE, USER_BANK_ACCOUNT_CREATE, USER_BANK_ACCOUNT_UPDATE } from '@/store/action.types'
import AvatarCroperEmployee from '@/views/branches/components/AvatarCroperEmployee'
export default {
  props: ['employee', 'userForm', 'formBank'],
  name: 'BranchEditEmployee',
  data() {
    return {
      uploadOptions: {
        select: 'Выбрать фото',
        change: 'Изменить фото',
        upload: '<p>Ваше устройство не поддерживается</p>',
        drag: 'Загрузить'
      }
    }
  },
  components: {
    AvatarCroperEmployee
  },
  computed: {
    validateForm1() {
      // check initial state for update
      return !this.errors.any() && this.formBank.account_number !== '' && this.formBank.bik !== '' && this.formBank.account_name !== ''
    },
    validateForm2() {
      return (
        !this.errors.any() && this.first_name !== ''
      )
    },
    prefillImage() {
      if (this.userForm.avatar) {
        return `${this.userForm.avatar}`
      }
      return require('@/assets/images/elements/photo_staff.png')
    }
  },
  mounted() {

  },
  methods: {
    getExtension(fileName) {
      return fileName.split('.').pop()
    },
    saveUserProfile(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.$vs.loading()
          const employee_payload = {
            id: this.employee,
            first_name: this.userForm.first_name,
            last_name: this.userForm.last_name,
            public_phrase: this.userForm.public_phrase,
            phone_number: this.userForm.phone_number,
            nickname: this.userForm.nickname,
            email: this.userForm.email,
            branch_page_show: this.userForm.branch_page_show,
            // avatar: this.avatar,
            notify: this.$vs.notify,
            new_password: this.userForm.new_password
          }
          const customValues = {
            name: !!employee_payload.first_name,
            surname: !!employee_payload.last_name,
            nickname: !!employee_payload.nickname,
            email: !!employee_payload.email,
            phrase: !!employee_payload.public_phrase,
            show: employee_payload.branch_page_show
          }
          this.$km_track('Employee', 'Save', 'Data', customValues)
          this.$store.dispatch(EMPLOYEE_UPDATE, employee_payload).then(() => {
            this.$vs.loading.close()
          })
            .catch(() => { this.$vs.loading.close() })
        }
      })
    },
    successUpload() {
      this.$vs.notify({
        title: 'Загрузка',
        text: 'Изображение успешно загружено'
      })
    },
    failUpload() {
      this.$vs.notify({
        title: 'Загрузка',
        text: 'Не удалось загрузить изображение'
      })
    },
    onChange(image) {
      if (image) {
        this.avatar = image
        const formData = new FormData()
        const extenstion = this.getExtension(this.$refs.pictureInput.file.name)
        const name = Math.random()
          .toString(36)
          .substring(7)
        const avatar = new File(
          [this.$refs.pictureInput.file],
          `${name}.${extenstion}`,
          {
            type: this.$refs.pictureInput.file.type
          }
        )
        formData.append('avatar', avatar)
        formData.append('user_id', this.employee)
        AuthService.saveUserImage(formData).then(response => {
          this.successUpload()
        })
      } else {
        this.failUpload()
      }
    },
    saveBankAccount(scope) {
      if (['044525444', '044525416'].includes(this.formBank.bik)) {
        this.$vs.notify({
          title: 'Ошибка',
          text: 'Вывод на карты и кошельки QIWI и Яндекс не поддерживается из-за правил использования кошельков.'
        })
      } else {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            this.$vs.loading()
            const payload = {
              'user_id': this.employee,
              'account_number': this.formBank.account_number,
              'bik': this.formBank.bik,
              'account_name': this.formBank.account_name,
              'notify': this.$vs.notify
            }
            const customValues = {
              account_number: !!payload.account_number,
              bik: !!payload.bik,
              fio: !!payload.account_name
            }
            this.$km_track('Employee', 'Save', 'Data', customValues)
            if (!this.formBank.exist) {
              this.$store.dispatch(USER_BANK_ACCOUNT_CREATE, payload).then(() => {
                this.$vs.loading.close()
              })
            } else {
              this.$store.dispatch(USER_BANK_ACCOUNT_UPDATE, payload).then(() => {
                this.$vs.loading.close()
              })
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="css">
  #save-button:hover {
    color: white!important;
    box-shadow: 0 8px 25px -8px rgba(var(--vs-primary),1);
  }
</style>
